/* lp-buy-box — <lp-buy-box>. Client-side product state from a JSON island (all products the box can show),
   /products/<handle>.js fallback for lp:product-change handles not on the page. Cart add via /cart/add.js then
   Impact's variant:add / cart:change so the theme drawer opens. Pricing numbers are display-only.
   data-style="compact": thumbnail row under the gallery, photos filtered to the picked colour, plain colour dots from
   the island's per-colour swatches,
   per-pair price + pack note, "10% off" tier labels, no size picked until the shopper picks one (a missing size
   flags the size row and focuses it). */
(function () {
  'use strict';
  if (window.customElements.get('lp-buy-box')) return;

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    if (!format) return '$' + v;
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v.replace(/\.00$/, function (m) { return format.indexOf('no_decimals') > -1 ? '' : m; }));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function isColour(n) { n = (n || '').toLowerCase(); return n === 'colour' || n === 'color'; }
  function isSize(n) { return (n || '').toLowerCase() === 'size'; }
  function isDefaultOnly(p) { return p.options.length === 1 && p.options[0].name === 'Title' && p.options[0].values.length === 1; }
  function shortSize(v) { v = String(v || ''); if (/^(Small|Medium|Large)$/.test(v)) return v.charAt(0); return v; }

  class LpBuyBox extends HTMLElement {
    connectedCallback() {
      var island = this.querySelector('[data-lp-products]');
      try { this.products = JSON.parse(island ? island.textContent : '{}'); } catch (e) { this.products = {}; }
      this.format = this.dataset.moneyFormat || '';
      this.form = this.querySelector('[data-lp-form]');
      this.gallery = this.querySelector('[data-lp-gallery]');
      var car = this.querySelector('[data-lp-carousel]'); this.ratio = car ? car.dataset.ratio : '4:5';
      this.qty = 1;
      this.compact = this.dataset.style === 'compact';
      this.sizeChosen = false;
      var tiers = (this.dataset.tiers || '1').split(',').map(function (n) { return parseInt(n, 10) || 1; });
      var def = parseInt(this.dataset.tierDefault, 10) || 1;
      this.tierCounts = tiers;
      if (this.querySelector('[data-lp-tiers]')) this.qty = tiers[Math.min(tiers.length, def) - 1] || 1;
      this.mode = this.dataset.pricingMode || 'value';
      var pairs = function (str) { return (str || '').split(',').filter(Boolean).map(function (p) { var a = p.split(':'); return { a: parseFloat(a[0]), b: parseFloat(a[1]) }; }).filter(function (t) { return t.a > 0 && !isNaN(t.b); }).sort(function (x, y) { return x.a - y.a; }); };
      this.valueTiers = pairs(this.dataset.valueTiers).map(function (t) { return { spend: t.a * 100, pct: t.b }; });
      this.fixedTiers = pairs(this.dataset.fixedTiers).map(function (t) { return { count: t.a, pct: t.b }; });
      this.dollarTiers = pairs(this.dataset.dollarTiers).map(function (t) { return { count: t.a, off: t.b * 100 }; });
      this.cartSubtotal = parseInt(this.dataset.cartSubtotal, 10) || 0;
      this.mixed = false; this.slots = [];
      this.selected = {};
      this.bind();
      this.watchCart();
      this.setProduct(this.dataset.handle, { initial: true });
      var self = this;
      if (window.LP) this.off = window.LP.on('product-change', function (e) { if (e.detail && e.detail.handle && e.detail.source !== 'lp-buy-box') self.setProduct(e.detail.handle); });
      this.initSticky();
      this.initCarousel();
    }
    disconnectedCallback() { if (this.off) this.off(); if (this.io) this.io.disconnect(); }

    bind() {
      var self = this;
      this.addEventListener('click', function (e) {
        var t;
        if ((t = e.target.closest('[data-lp-fit-option]'))) { e.preventDefault(); self.setProduct(t.dataset.lpFitOption, { announce: true }); return; }
        if ((t = e.target.closest('[data-lp-fit-group]'))) { e.preventDefault(); if (t.dataset.lpFitFirst) self.setProduct(t.dataset.lpFitFirst, { announce: true }); return; }
        if ((t = e.target.closest('[data-lp-sibling]'))) { e.preventDefault(); self.setProduct(t.dataset.lpSibling, { announce: true }); return; }
        if ((t = e.target.closest('[data-lp-option]'))) { e.preventDefault(); self.select(t.dataset.lpOption, t.dataset.lpValue); return; }
        if ((t = e.target.closest('[data-lp-tier]'))) { e.preventDefault(); self.setQty(parseInt(t.dataset.lpTier, 10) || 1); return; }
        if ((t = e.target.closest('[data-lp-size-guide]'))) { e.preventDefault(); var d = self.querySelector('[data-lp-size-dialog]'); if (d && d.showModal) d.showModal(); return; }
        if ((t = e.target.closest('[data-lp-sticky-btn]'))) { e.preventDefault(); self.add(); return; }
        if ((t = e.target.closest('[data-lp-popup]'))) { e.preventDefault(); self.openPopup(t.dataset.lpPopup, t.dataset.lpForm); return; }
      });
      if (this.form) this.form.addEventListener('submit', function (e) { e.preventDefault(); self.add(); });
      this.addEventListener('click', function (e) { var t = e.target.closest('[data-lp-mix-toggle]'); if (t) { e.preventDefault(); self.mixed = !self.mixed; self.slots = []; self.render(); } });
      this.addEventListener('change', function (e) {
        var row = e.target.closest('[data-lp-slot]'); if (!row) return;
        var i = parseInt(row.dataset.lpSlot, 10), slot = self.slots[i]; if (!slot) return;
        if (e.target.hasAttribute('data-lp-slot-colour')) { var parts = e.target.value.split('|'); slot.handle = parts[0]; slot.colour = parts[1] || ''; var sizes = self.sizesFor(slot.handle, slot.colour); if (!sizes.some(function (s) { return s.value === slot.size && s.available; })) { var first = sizes.filter(function (s) { return s.available; })[0]; slot.size = first ? first.value : ''; } }
        if (e.target.hasAttribute('data-lp-slot-size')) slot.size = e.target.value;
        self.renderMix(self.variant() ? self.variant().price : 0);
      });
      var up = this.querySelector('[data-lp-upsell]'); if (up) up.addEventListener('change', function () { self.render(); });
      var inc = this.querySelector('[data-lp-qty-inc]'), dec = this.querySelector('[data-lp-qty-dec]'), inp = this.querySelector('[data-lp-qty-input]');
      if (inc) inc.addEventListener('click', function () { self.setQty(Math.min(99, self.qty + 1)); });
      if (dec) dec.addEventListener('click', function () { self.setQty(Math.max(1, self.qty - 1)); });
      if (inp) inp.addEventListener('change', function () { var n = parseInt(inp.value, 10); self.setQty(isNaN(n) || n < 1 ? 1 : Math.min(99, n)); });
    }

    /* ---------- product ---------- */
    setProduct(handle, opts) {
      opts = opts || {};
      var self = this;
      var p = this.products[handle];
      if (!p) {
        fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
          if (!j) return;
          self.products[handle] = {
            handle: j.handle, title: j.title, url: '/products/' + j.handle, colour: '', swatch: '',
            options: j.options.map(function (o) { return { name: o.name, values: o.values }; }),
            images: (j.media || []).filter(function (m) { return m.media_type === 'image'; }).map(function (m) { return { src: m.src, alt: m.alt || '', id: m.id }; }),
            variants: j.variants.map(function (v) { return { id: v.id, title: v.title, options: v.options, available: v.available, price: v.price, compare_at_price: v.compare_at_price || 0, image_id: v.featured_media ? v.featured_media.id : 0 }; })
          };
          self.setProduct(handle, opts);
        }).catch(function () {});
        return;
      }
      var prevSize = this.sizeName ? this.selected[this.sizeName] : null;
      var prevColour = this.colourName ? this.selected[this.colourName] : null;
      this.product = p;
      this.dataset.handle = handle;
      this.colourName = null; this.sizeName = null;
      p.options.forEach(function (o) { if (isColour(o.name)) self.colourName = o.name; if (isSize(o.name)) self.sizeName = o.name; });
      this.selected = {}; this.mixed = false; this.slots = [];
      var firstAvail = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
      p.options.forEach(function (o, i) { self.selected[o.name] = firstAvail ? firstAvail.options[i] : o.values[0]; });
      if (this.sizeName && prevSize && p.options.some(function (o) { return isSize(o.name) && o.values.indexOf(prevSize) > -1; })) this.selected[this.sizeName] = prevSize;
      if (this.compact && this.sizeName && !this.sizeChosen) delete this.selected[this.sizeName];
      /* compact: switching style keeps the picked colour when the new product has it */
      if (this.compact && this.colourName && prevColour && p.options.some(function (o) { return o.name === self.colourName && o.values.indexOf(prevColour) > -1; })) this.selected[this.colourName] = prevColour;
      if (!opts.initial || this.dataset.gallery !== 'static') this.renderGallery(!!opts.initial);
      this.renderColours();
      this.render();
      Array.prototype.forEach.call(this.querySelectorAll('[data-lp-fit-option]'), function (b) { b.setAttribute('aria-pressed', b.dataset.lpFitOption === handle); });
      /* grouped fit switch: show the active option's group, press its tab */
      var active = this.querySelector('[data-lp-fit-option="' + handle + '"]');
      if (active && active.hasAttribute('data-lp-fit-in')) {
        var group = active.dataset.lpFitIn;
        Array.prototype.forEach.call(this.querySelectorAll('[data-lp-fit-in]'), function (b) { b.hidden = b.dataset.lpFitIn !== group; });
        Array.prototype.forEach.call(this.querySelectorAll('[data-lp-fit-group]'), function (b) { b.setAttribute('aria-pressed', b.dataset.lpFitGroup === group); });
      }
      Array.prototype.forEach.call(this.querySelectorAll('[data-lp-sibling]'), function (b) { b.setAttribute('aria-pressed', b.dataset.lpSibling === handle); });
      if (opts.announce && window.LP) window.LP.emit('product-change', { handle: handle, source: 'lp-buy-box' });
    }
    select(name, value) {
      if (name === this.sizeName) this.sizeChosen = true;
      this.selected[name] = value;
      if (this.compact && name === this.colourName) this.renderGallery();
      this.render();
    }
    /* note block: the site's sign-up pop-up (Alia's public window.alia.open), else the Klaviyo form id */
    openPopup(kind, form) {
      if (kind === 'alia' && window.alia && typeof window.alia.open === 'function') { window.alia.open(); return; }
      if (form) { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', form]); }
    }
    fitButton(handle) { return this.querySelector('[data-lp-fit-option="' + handle + '"]'); }
    /* compact: no size yet — mark the size row and move focus to the first size that can be bought */
    flagSize() {
      var box = this.querySelector('[data-lp-size-buttons]'); if (!box || !this.sizeName || this.selected[this.sizeName]) return;
      box.classList.add('is-need');
      var first = box.querySelector('[data-lp-option]:not([disabled])'); if (first) first.focus();
    }
    setQty(n) { this.qty = n; this.slots = this.slots.slice(0, n); this.render(); }

    variant() {
      var self = this, p = this.product; if (!p) return null;
      return p.variants.filter(function (v) { return p.options.every(function (o, i) { return v.options[i] === self.selected[o.name]; }); })[0] || null;
    }
    /* variants matching `value` for option `name`, with every other option held at the current selection
       (size is left free when testing a non-size option so a colour is not marked sold out by one missing size) */
    variantFor(name, value) {
      var self = this, p = this.product;
      return p.variants.filter(function (v) { return p.options.every(function (o, i) {
        if (o.name === name) return v.options[i] === value;
        if (isSize(o.name) && !isSize(name)) return true;
        return v.options[i] === self.selected[o.name];
      }); });
    }
    /* options that are neither colour nor size (e.g. Absorbency) render as pill groups */
    renderExtraOptions() {
      var box = this.querySelector('[data-lp-extra-options]'); if (!box) return;
      var self = this, p = this.product;
      if (isDefaultOnly(p)) { box.innerHTML = ''; return; }
      var includeSize = box.hasAttribute('data-lp-include-size');
      var extras = p.options.filter(function (o) { return !isColour(o.name) && (includeSize || !isSize(o.name)); });
      box.innerHTML = extras.map(function (o) {
        return '<fieldset class="lp-buy-box__group" data-lp-option-group="' + esc(o.name) + '"><legend class="lp-buy-box__label">' + esc(o.name) + ' <span class="lp-buy-box__label-value">' + esc(self.selected[o.name] || '') + '</span></legend><div class="lp-buy-box__pills">' +
          o.values.map(function (val) {
            var avail = self.variantFor(o.name, val).some(function (x) { return x.available; });
            return '<button type="button" class="lp-buy-box__pill" data-lp-option="' + esc(o.name) + '" data-lp-value="' + esc(val) + '" aria-pressed="' + (self.selected[o.name] === val) + '"' + (avail ? '' : ' data-sold-out') + '>' + esc(isSize(o.name) ? shortSize(val) : val) + '</button>';
          }).join('') + '</div></fieldset>';
      }).join('');
    }

    /* ---------- render ---------- */
    /* compact: photos for the picked colour. A photo belongs to a colour when its file name or alt names it (WHITE in
       SOCKS_CREW_WHITE_3.png). Photos naming no colour can't be placed (image_2.png may show white socks), so they
       only show when the picked colour has no photos of its own; then the untagged ones, else everything. */
    galleryImages() {
      var p = this.product, all = p.images || [];
      if (!this.compact || !this.colourName) return all;
      var opt = p.options.filter(function (o) { return o.name === this.colourName; }, this)[0]; if (!opt) return all;
      var words = function (v) { return new RegExp('(^|[^a-z])' + String(v).toLowerCase().replace(/[^a-z0-9]+/g, '[^a-z0-9]?') + '([^a-z]|$)'); };
      var res = opt.values.map(words), pick = opt.values.indexOf(this.selected[this.colourName]);
      var key = function (im) { return ((im.src || '').split('?')[0].split('/').pop() + ' ' + (im.alt || '')).toLowerCase(); };
      var own = all.filter(function (im) { return res[pick] && res[pick].test(key(im)); });
      if (own.length) return own;
      var untagged = all.filter(function (im) { var k = key(im); return !res.some(function (r) { return r.test(k); }); });
      return untagged.length ? untagged : all;
    }
    renderGallery(initial) {
      if (!this.gallery || this.dataset.gallery === 'static') return;
      if (initial && !this.compact) return; /* server-rendered for the initial product */
      var self = this, list = this.galleryImages(), sig = list.map(function (im) { return im.id; }).join(',');
      if (sig === this.gallerySig) return;
      this.gallerySig = sig;
      this.gallery.innerHTML = list.map(function (im, i) {
        return '<div class="lp-buy-box__slide" data-media-id="' + im.id + '"><div class="lp-media" data-ratio="' + (self.ratio || '4:5') + '"><img src="' + esc(im.src) + '" alt="' + esc(im.alt) + '" loading="' + (i === 0 ? 'eager' : 'lazy') + '" width="1200" height="' + (self.ratio === '1:1' ? 1200 : 1500) + '"></div></div>';
      }).join('');
      this.gallery.scrollTo({ left: 0 });
      this.syncCarousel();
    }
    renderColours() {
      var box = this.querySelector('[data-lp-colours]'); if (!box) return;
      var wrap = box.querySelector('[data-lp-swatches]'), self = this, p = this.product;
      if (box.dataset.source === 'variants') {
        if (!this.colourName || isDefaultOnly(p)) { box.hidden = true; return; }
        box.hidden = false;
        var opt = p.options.filter(function (o) { return o.name === self.colourName; })[0];
        var idx = p.options.indexOf(opt);
        wrap.innerHTML = opt.values.map(function (val) {
          var vs = p.variants.filter(function (v) { return v.options[idx] === val; });
          var img = vs.map(function (v) { return v.image_id; }).filter(Boolean)[0];
          var im = p.images.filter(function (i) { return i.id === img; })[0];
          var bg = im ? 'url(' + im.src.replace(/width=\d+/, 'width=240') + ')' : '';
          /* compact: plain dots — the colour swatch config, else the colour name when it is a CSS colour ("White"), else the photo */
          if (self.compact) { var cfg = p.swatches && p.swatches[val]; if (cfg) bg = cfg; else if (window.CSS && CSS.supports('color', val)) bg = val.toLowerCase(); }
          var avail = vs.some(function (v) { return v.available; });
          return '<button type="button" class="lp-buy-box__swatch lp-buy-box__swatch--' + esc(box.dataset.style) + '" data-lp-option="' + esc(opt.name) + '" data-lp-value="' + esc(val) + '" aria-label="' + esc(val) + '" aria-pressed="false" style="--lp-swatch: ' + bg + '"' + (avail ? '' : ' data-sold-out') + '></button>';
        }).join('');
      } else {
        box.hidden = wrap.children.length === 0;
      }
    }
    render() {
      var self = this, p = this.product; if (!p) return;
      var v = this.variant();
      var fb = this.fitButton(p.handle), fitLabel = fb ? fb.textContent.trim() : '';
      var t = this.querySelector('[data-lp-title]'); if (t) t.textContent = t.dataset.lpTitleSuffix && fitLabel ? fitLabel + ' ' + t.dataset.lpTitleSuffix : p.title;
      var fn = this.querySelector('[data-lp-fit-name]'); if (fn) fn.textContent = fitLabel;
      var st = this.querySelector('[data-lp-sticky-title]'); if (st) st.textContent = p.title;
      var si = this.querySelector('.lp-buy-box__sticky-img'); if (si && p.images && p.images[0]) { si.src = p.images[0].src.replace(/width=\d+/, 'width=120'); si.alt = p.images[0].alt || p.title; }

      /* colour label + swatch state */
      Array.prototype.forEach.call(this.querySelectorAll('[data-lp-option]'), function (b) { b.setAttribute('aria-pressed', self.selected[b.dataset.lpOption] === b.dataset.lpValue); });
      var cn = this.querySelector('[data-lp-colour-name]'); if (cn) cn.textContent = this.colourName ? this.selected[this.colourName] : (p.colour || '');

      this.renderExtraOptions();

      /* sizes */
      var sizes = this.querySelector('[data-lp-size-buttons]');
      if (sizes) {
        if (this.sizeName) {
          var so = p.options.filter(function (o) { return o.name === self.sizeName; })[0];
          sizes.innerHTML = so.values.map(function (val) {
            var avail = self.variantFor(self.sizeName, val).some(function (x) { return x.available; });
            return '<button type="button" class="lp-buy-box__size" data-lp-option="' + esc(so.name) + '" data-lp-value="' + esc(val) + '" aria-pressed="' + (self.selected[so.name] === val) + '"' + (avail ? '' : ' disabled aria-disabled="true"') + '>' + esc(shortSize(val)) + '</button>';
          }).join('');
          var sn = this.querySelector('[data-lp-size-name]'); if (sn) sn.textContent = this.selected[this.sizeName] || '';
          sizes.closest('[data-lp-sizes]').hidden = false;
        } else { sizes.closest('[data-lp-sizes]').hidden = true; }
      }

      if (!this.compact && v && v.image_id && this.gallery && this.dataset.gallery !== 'static') { var slides = this.gallery.children; for (var k = 0; k < slides.length; k++) { if (String(slides[k].dataset.mediaId) === String(v.image_id)) { this.goTo(k); break; } } }

      /* price */
      var unit = v ? v.price : (p.variants[0] ? p.variants[0].price : 0);
      var compare = v && v.compare_at_price > v.price ? v.compare_at_price : 0;
      var pr = this.querySelector('[data-lp-price]'); if (pr) pr.textContent = money(unit, this.format);
      if (this.compact) {
        var each = this.unitFor(unit, this.qty), us = this.dataset.unitS || 'pair', up = this.dataset.unitP || 'pairs';
        if (pr) pr.textContent = money(each, this.format);
        var pn = this.querySelector('[data-lp-price-note]'); if (pn) pn.textContent = this.qty === 1 ? 'single ' + us : 'per ' + us + ' · ' + this.qty + ' ' + up + ' ' + money(each * this.qty, this.format);
      }
      var cp = this.querySelector('[data-lp-compare]'); if (cp) { cp.hidden = !compare; cp.textContent = compare ? money(compare, this.format) : ''; }

      /* tiers */
      var self2 = this;
      Array.prototype.forEach.call(this.querySelectorAll('[data-lp-tier]'), function (b) {
        var n = parseInt(b.dataset.lpTier, 10) || 1;
        b.setAttribute('aria-pressed', n === self2.qty);
        var tp = b.querySelector('[data-lp-tier-price]'); if (tp) tp.textContent = money(self2.unitFor(unit, n), self2.format);
        var pct = self2.pctFor(unit, n);
        var ts = b.querySelector('[data-lp-tier-save]'); if (ts) { ts.hidden = !pct; ts.textContent = pct ? (self2.compact ? pct + '% off' : 'Save ' + pct + '%') : ''; }
      });
      var tiersBox = this.querySelector('[data-lp-tiers]'); if (tiersBox) tiersBox.style.setProperty('--lp-buy-box-tier-cols', String(Math.min(4, tiersBox.querySelectorAll('[data-lp-tier]').length || 2)));
      var total = this.unitFor(unit, this.qty) * this.qty;
      var nudge = this.querySelector('[data-lp-nudge]');
      if (nudge) { var msg = this.nudgeText(unit, this.qty); nudge.hidden = !msg; nudge.textContent = msg; }
      this.renderMix(unit);

      /* atc */
      var btn = this.querySelector('[data-lp-atc]'), label = this.querySelector('[data-lp-atc-label]'), tot = this.querySelector('[data-lp-atc-total]');
      var qi = this.querySelector('[data-lp-qty-input]'); if (qi) qi.value = this.qty;
      var qtyBox = this.querySelector('[data-lp-qty]'); if (qtyBox) qtyBox.hidden = this.mixed || this.mode === 'none' && false;
      var soldOut = !p.variants.some(function (x) { return x.available; });
      var sizeMissing = this.sizeName && !this.selected[this.sizeName];
      if (btn) { btn.disabled = soldOut || (v && !v.available); }
      if (label) label.textContent = soldOut ? label.dataset.soldOut : (v && !v.available ? label.dataset.soldOut : label.dataset.label);
      if (tot) tot.textContent = soldOut ? '' : money(total, this.format);
      var sb = this.querySelector('[data-lp-sticky-btn]'); if (sb) sb.disabled = !!(btn && btn.disabled);
      var err = this.querySelector('[data-lp-size-error]'); if (err) err.hidden = true;
      if (sizes) sizes.classList.remove('is-need');
    }
    /* ---- pricing, ported from s1-pdp: unit price for `count` pairs of the current variant ----
       none   → full price
       dollar → largest tier count at or below `count` takes a flat amount off every pair
       fixed  → largest tier count at or below `count` has its own percentage
       value  → % from order-value tiers matched against cart subtotal + count × price */
    tierAtOrBelow(list, count) { var hit = list.filter(function (t) { return count >= t.count; }); return hit.length ? hit[hit.length - 1] : null; }
    pctFor(unit, count) {
      if (this.mode === 'none') return 0;
      if (this.mode === 'fixed') { var f = this.tierAtOrBelow(this.fixedTiers, count); return f ? f.pct : 0; }
      if (this.mode === 'dollar') { var d = this.tierAtOrBelow(this.dollarTiers, count); return d && unit ? Math.round((d.off / unit) * 100) : 0; }
      var projected = this.cartSubtotal + unit * count;
      var v = this.valueTiers.filter(function (t) { return projected >= t.spend; }); return v.length ? v[v.length - 1].pct : 0;
    }
    unitFor(unit, count) {
      if (this.mode === 'dollar') { var d = this.tierAtOrBelow(this.dollarTiers, count); return Math.max(0, unit - (d ? d.off : 0)); }
      return Math.round(unit * (1 - this.pctFor(unit, count) / 100));
    }
    nudgeText(unit, count) {
      if (this.mode !== 'value') { var p = this.pctFor(unit, count); return p ? p + '% off applied at checkout' : ''; }
      var projected = this.cartSubtotal + unit * count, cur = this.pctFor(unit, count);
      var next = this.valueTiers.filter(function (t) { return projected < t.spend && t.pct > cur; })[0];
      if (next) return 'Add ' + money(next.spend - projected, this.format) + ' more to unlock ' + next.pct + '% off';
      return cur ? cur + '% off applied at checkout' : '';
    }
    /* keep the cart subtotal current: initial /cart.js, then Impact's cart:change and our own adds */
    watchCart() {
      var self = this, seq = 0;
      var refresh = function () {
        var my = ++seq;
        fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
          if (my !== seq) return;
          self.cartSubtotal = c.original_total_price || c.total_price || 0;
          self.render();
        }).catch(function () {});
      };
      refresh();
      document.documentElement.addEventListener('cart:change', refresh);
      document.addEventListener('cart:refresh', refresh);
      if (window.LP) window.LP.on('cart-add', refresh);
    }

    /* ---------- mixed pack: N slots, each a colour (this product's colour option, or a sibling/fit product) + size ---------- */
    colourChoices() {
      var self = this, p = this.product, out = [];
      if (this.colourName) {
        var idx = p.options.map(function (o) { return o.name; }).indexOf(this.colourName);
        p.options[idx].values.forEach(function (val) { out.push({ key: p.handle + '|' + val, handle: p.handle, colour: val, label: val }); });
      } else {
        Object.keys(this.products).forEach(function (h) { var q = self.products[h]; out.push({ key: h + '|', handle: h, colour: '', label: q.colour || q.title }); });
      }
      return out;
    }
    sizesFor(handle, colour) {
      var q = this.products[handle]; if (!q) return [];
      var sIdx = q.options.map(function (o) { return o.name; }).indexOf(q.options.filter(function (o) { return isSize(o.name); }).map(function (o) { return o.name; })[0]);
      var cIdx = q.options.map(function (o) { return o.name; }).indexOf(q.options.filter(function (o) { return isColour(o.name); }).map(function (o) { return o.name; })[0]);
      if (sIdx < 0) return [];
      return q.options[sIdx].values.map(function (val) {
        var v = q.variants.filter(function (x) { return x.options[sIdx] === val && (cIdx < 0 || !colour || x.options[cIdx] === colour); })[0];
        return { value: val, id: v ? v.id : 0, available: !!(v && v.available) };
      });
    }
    renderMix(unit) {
      var mix = this.querySelector('[data-lp-mix]'); if (!mix) return;
      var canMix = this.qty > 1 && this.mode !== 'none';
      mix.hidden = !canMix;
      if (!canMix) { if (this.mixed) { this.mixed = false; } return; }
      var lbl = mix.querySelector('[data-lp-mix-label]'), tog = mix.querySelector('[data-lp-mix-toggle]'), box = mix.querySelector('[data-lp-slots]');
      if (lbl) lbl.textContent = this.mixed ? lbl.dataset.off : lbl.dataset.on;
      if (tog) tog.setAttribute('aria-expanded', this.mixed);
      box.hidden = !this.mixed;
      if (!this.mixed) return;
      var self = this, cur = this.variant(), curColour = this.colourName ? this.selected[this.colourName] : '', curSize = this.sizeName ? this.selected[this.sizeName] : '';
      while (this.slots.length < this.qty) this.slots.push({ handle: this.product.handle, colour: curColour, size: curSize });
      this.slots.length = this.qty;
      var colours = this.colourChoices();
      box.innerHTML = this.slots.map(function (slot, i) {
        var sizes = self.sizesFor(slot.handle, slot.colour);
        return '<div class="lp-buy-box__slot" data-lp-slot="' + i + '"><span class="lp-buy-box__slot-n">' + (i + 1) + '</span>' +
          '<select class="lp-buy-box__slot-select" data-lp-slot-colour aria-label="Colour for pair ' + (i + 1) + '">' + colours.map(function (c) { return '<option value="' + esc(c.key) + '"' + (c.handle === slot.handle && c.colour === slot.colour ? ' selected' : '') + '>' + esc(c.label) + '</option>'; }).join('') + '</select>' +
          '<select class="lp-buy-box__slot-select" data-lp-slot-size aria-label="Size for pair ' + (i + 1) + '">' + sizes.map(function (sz) { return '<option value="' + esc(sz.value) + '"' + (sz.value === slot.size ? ' selected' : '') + (sz.available ? '' : ' disabled') + '>' + esc(shortSize(sz.value)) + (sz.available ? '' : ' · sold out') + '</option>'; }).join('') + '</select></div>';
      }).join('');
    }
    mixedItems() {
      var self = this, map = {};
      this.slots.forEach(function (slot) {
        var sz = self.sizesFor(slot.handle, slot.colour).filter(function (s) { return s.value === slot.size && s.available; })[0];
        if (!sz) return;
        map[sz.id] = (map[sz.id] || 0) + 1;
      });
      var items = Object.keys(map).map(function (id) { return { id: parseInt(id, 10), quantity: map[id] }; });
      var total = items.reduce(function (n, it) { return n + it.quantity; }, 0);
      return total === this.qty ? items : [];
    }

    /* ---------- cart ---------- */
    add() {
      var v = this.variant(), btn = this.querySelector('[data-lp-atc]'), err = this.querySelector('[data-lp-cart-error]');
      if (!this.mixed && (!v || !v.available)) { var se = this.querySelector('[data-lp-size-error]'); if (se) se.hidden = false; if (this.compact) this.flagSize(); return; }
      if (this.mixed) v = v || this.product.variants[0];
      if (btn && btn.getAttribute('aria-busy') === 'true') return;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var items = this.mixed ? this.mixedItems() : [{ id: v.id, quantity: this.qty }];
      if (!items.length) { var se2 = this.querySelector('[data-lp-size-error]'); if (se2) se2.hidden = false; return; }
      var up = this.querySelector('[data-lp-upsell]'); if (up && up.checked && up.value) items.push({ id: parseInt(up.value, 10), quantity: 1 });
      var sections = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
      if (btn) { btn.setAttribute('aria-busy', 'true'); }
      var self = this;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: root + 'variants/' + v.id }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (btn) btn.removeAttribute('aria-busy');
          if (!res.ok) { if (err) { err.hidden = false; err.textContent = (res.json && res.json.description) || 'Could not add to cart. Please try again.'; } return; }
          if (err) err.hidden = true;
          return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            cart.sections = res.json.sections || (res.json.items && res.json.items.length ? res.json.sections : undefined);
            if (!cart.sections) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            self.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: res.json.items || [res.json], cart: cart } }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
            if (window.LP) window.LP.emit('cart-add', { items: items, cart: cart, source: 'lp-buy-box' });
          });
        })
        .catch(function () { if (btn) btn.removeAttribute('aria-busy'); if (err) { err.hidden = false; err.textContent = 'Could not add to cart. Please try again.'; } });
    }

    /* ---------- gallery carousel: arrows + dots over native scroll-snap ---------- */
    initCarousel() {
      var wrap = this.querySelector('[data-lp-carousel]'); if (!wrap || !this.gallery) return;
      var self = this;
      this.dots = wrap.querySelector('[data-lp-dots]');
      var prev = wrap.querySelector('[data-lp-prev]'), next = wrap.querySelector('[data-lp-next]');
      if (prev) prev.addEventListener('click', function () { self.goTo(self.slideIndex() - 1); });
      if (next) next.addEventListener('click', function () { self.goTo(self.slideIndex() + 1); });
      if (this.dots) this.dots.addEventListener('click', function (e) { var d = e.target.closest('[data-lp-dot]'); if (d) self.goTo(parseInt(d.dataset.lpDot, 10)); });
      var thumbs = wrap.querySelector('[data-lp-thumbs]');
      if (thumbs) thumbs.addEventListener('click', function (e) { var b = e.target.closest('[data-lp-thumb]'); if (b) self.goTo(parseInt(b.dataset.lpThumb, 10)); });
      var t; this.gallery.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { self.updateCarousel(); }, 60); }, { passive: true });
      this.syncCarousel();
    }
    slideIndex() { var w = this.gallery.clientWidth || 1; return Math.round(this.gallery.scrollLeft / w); }
    goTo(i) {
      var n = this.gallery.children.length; if (!n) return;
      i = Math.max(0, Math.min(n - 1, i));
      this.gallery.scrollTo({ left: i * this.gallery.clientWidth, behavior: (window.LP && window.LP.motionOK) ? 'smooth' : 'auto' });
    }
    syncCarousel() {
      var wrap = this.querySelector('[data-lp-carousel]'); if (!wrap) return;
      var n = this.gallery.children.length; wrap.dataset.count = n;
      if (this.dots) this.dots.innerHTML = Array.prototype.map.call(this.gallery.children, function (_, i) { return '<button type="button" class="lp-buy-box__dot" role="tab" data-lp-dot="' + i + '" aria-label="Image ' + (i + 1) + '" aria-selected="' + (i === 0) + '"></button>'; }).join('');
      var thumbs = wrap.querySelector('[data-lp-thumbs]');
      if (thumbs) thumbs.innerHTML = Array.prototype.map.call(this.gallery.children, function (sl, i) {
        var im = sl.querySelector('img'), src = im ? (im.getAttribute('src') || '').replace(/width=\d+/, 'width=160') : '';
        return '<button type="button" class="lp-buy-box__thumb" data-lp-thumb="' + i + '" aria-label="Photo ' + (i + 1) + '" aria-pressed="' + (i === 0) + '">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="160" height="160">' : '') + '</button>';
      }).join('');
      this.updateCarousel();
    }
    updateCarousel() {
      var wrap = this.querySelector('[data-lp-carousel]'); if (!wrap) return;
      var i = this.slideIndex(), n = this.gallery.children.length;
      Array.prototype.forEach.call(wrap.querySelectorAll('[data-lp-dot]'), function (d, k) { d.setAttribute('aria-selected', k === i); });
      Array.prototype.forEach.call(wrap.querySelectorAll('[data-lp-thumb]'), function (d, k) { d.setAttribute('aria-pressed', k === i); });
      var prev = wrap.querySelector('[data-lp-prev]'), next = wrap.querySelector('[data-lp-next]');
      if (prev) prev.disabled = i <= 0; if (next) next.disabled = i >= n - 1;
    }

    /* ---------- sticky mobile ATC: visible while the box is on screen but the main button is not ---------- */
    initSticky() {
      var bar = this.querySelector('[data-lp-sticky]'), btn = this.querySelector('[data-lp-atc]');
      if (!bar || !btn || !('IntersectionObserver' in window)) return;
      var self = this; this.boxVisible = false; this.btnVisible = true;
      var update = function () { var show = self.boxVisible && !self.btnVisible && window.innerWidth < 768; bar.hidden = !show; };
      this.io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.target === self) self.boxVisible = e.isIntersecting; if (e.target === btn) self.btnVisible = e.isIntersecting; });
        update();
      }, { threshold: [0, 0.01] });
      this.io.observe(this); this.io.observe(btn);
      window.addEventListener('resize', update, { passive: true });
    }
  }
  window.customElements.define('lp-buy-box', LpBuyBox);
})();
